// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== 隐藏所有文字内容 - 纯图片效果 ========== */
.announcement-content,
.announcement-title,
.announcement-text,
.priority-badge,
.priority-high .priority-badge,
.priority-medium .priority-badge,
.priority-low .priority-badge,
.announcement-item .announcement-title,
.announcement-item .announcement-text,
.announcement-item .announcement-content,
.carousel-item .announcement-title,
.carousel-item .announcement-text,
.carousel-item .announcement-content,
.has-image .announcement-title,
.has-image .announcement-text,
.has-image .announcement-content {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* 确保图片覆盖整个容器 */
.announcement-item.has-image .announcement-background-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.announcement-item.has-image .announcement-background-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/* 隐藏图片叠加层，保持纯净的图片效果 */
.image-overlay {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* 黑色磨砂玻璃效果 - 无动画版本 */

/* 🔥 强制生效 - 最高优先级样式 */
.announcement-board,
.card.announcement-board,
div.announcement-board {
  background: rgba(0, 0, 0, 0.7) !important;
  backdrop-filter: blur(25px) saturate(130%) !important;
  -webkit-backdrop-filter: blur(25px) saturate(130%) !important;
  border: 2px solid rgba(255, 255, 255, 0.25) !important;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.8),
    0 8px 20px rgba(0, 0, 0, 0.5),
    inset 0 2px 0 rgba(255, 255, 255, 0.15) !important;
}

/* 强制取消所有左边框 */
.announcement-board *,
.announcement-board .announcement-item,
.announcement-board .card-body,
.announcement-board .card-body * {
  border-left: none !important;
  border-left-color: transparent !important;
  border-left-width: 0 !important;
}

/* 强制覆盖Bootstrap默认样式 */
.card-header.announcement-header {
  background-color: rgba(0, 0, 0, 0.9) !important;
  background: rgba(0, 0, 0, 0.9) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
}

.announcement-board {
  /* 黑色磨砂玻璃核心样式 - 始终生效，增强效果 */
  background: rgba(0, 0, 0, 0.6) !important;
  backdrop-filter: blur(20px) saturate(120%) !important;
  -webkit-backdrop-filter: blur(20px) saturate(120%) !important;
  
  /* 边框和阴影 - 始终生效，增强效果 */
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 
    0 15px 50px rgba(0, 0, 0, 0.7),
    0 6px 16px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
  
  /* 基础样式 */
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 24px;
  position: relative;
  transition: none !important; /* 取消动画 */
}

/* 简单的磨砂反光层 */
.announcement-board::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.08) 0%,
    rgba(255, 255, 255, 0.02) 50%,
    rgba(255, 255, 255, 0.08) 100%);
  pointer-events: none;
  z-index: 1;
  opacity: 0.5;
}

/* 移除悬浮效果，让效果始终保持 */
.announcement-board:hover {
  /* 保持和默认状态一样的效果 */
  background: rgba(0, 0, 0, 0.6) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  box-shadow: 
    0 15px 50px rgba(0, 0, 0, 0.7),
    0 6px 16px rgba(0, 0, 0, 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
}

/* 黑色磨砂头部 - 增强黑色背景，提高优先级 */
.announcement-board .card-header.announcement-header,
.announcement-board .card-header,
.announcement-board .announcement-header {
  background: rgba(0, 0, 0, 0.9) !important;
  backdrop-filter: blur(15px) !important;
  -webkit-backdrop-filter: blur(15px) !important;
  color: white !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;
  padding: 20px 24px !important;
  position: relative;
  z-index: 3;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.announcement-board .card-header.announcement-header h5,
.announcement-board .card-header h5,
.announcement-board .announcement-header h5 {
  color: white !important;
  font-weight: 600;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  margin: 0;
}

.announcement-board .card-header.announcement-header .badge,
.announcement-board .card-header .badge,
.announcement-board .announcement-header .badge {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #333 !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.announcement-board .header-icon {
  font-size: 1.3em;
  margin-right: 10px;
  color: white !important;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.8));
}

/* 公告内容区域 - 支持背景图片和文字叠加 */
.announcement-item {
  position: relative;
  padding: 32px;
  margin: 0;
  background: rgba(16, 24, 40, 0.4);
  backdrop-filter: blur(8px);
  border-radius: 0;
  overflow: hidden;
  min-height: 250px; /* 确保有足够高度显示内容 */
  display: flex;
  align-items: flex-start; /* 改为顶部对齐 */
  justify-content: center;
  border-left: none !important; /* 取消左边框 */
  transition: none !important; /* 取消动画 */
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
}

/* 有背景图片时的样式 */
.announcement-item.has-image {
  background: transparent; /* 移除默认背景 */
  min-height: 320px; /* 增加高度以更好展示图片 */
}

/* 背景图片容器 */
.announcement-background-image {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  overflow: hidden;
}

.announcement-background-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  filter: brightness(0.7) contrast(1.1); /* 稍微暗化以突出文字 */
}

/* 图片遮罩层 - 增强文字可读性 */
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0.7) 100%
  );
  z-index: 2;
}

.announcement-item:hover {
  /* 保持和默认状态一样的效果 */
  background: rgba(0, 0, 0, 0.3) !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;
}

/* 有背景图片时悬浮效果不改变背景 */
.announcement-item.has-image:hover {
  background: transparent !important;
}

/* 优先级样式 - 取消左边框，改用背景色区分 */
.announcement-item.priority-high {
  border-left: none !important; /* 取消左边框 */
}

.announcement-item.priority-medium {
  border-left: none !important; /* 取消左边框 */
}

.announcement-item.priority-low {
  border-left: none !important; /* 取消左边框 */
}

/* 有背景图片时的优先级样式（不显示背景色，通过标签区分） */
.announcement-item.has-image.priority-high,
.announcement-item.has-image.priority-medium,
.announcement-item.has-image.priority-low {
  background: transparent !important;
}

/* 文字样式 - 叠加在图片上 */
.announcement-content {
  position: relative;
  z-index: 3;
  width: 100%;
  text-align: center; /* 文字居中显示 */
  padding: 20px 20px 0 20px; /* 上方增加内边距，底部减少 */
}

/* 增强文字可读性 - 在有背景图片时 */
.announcement-item.has-image .announcement-content {
  text-align: center;
  padding: 30px 40px 0 40px; /* 顶部增加更多内边距 */
}

.announcement-title {
  font-size: 24px; /* 增大字体 */
  font-weight: 800; /* 更粗的字体 */
  color: #ffffff;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center; /* 居中对齐 */
  line-height: 1.3;
  letter-spacing: 0.5px;
  text-shadow: 
    0 2px 4px rgba(0, 0, 0, 0.8),
    0 0 8px rgba(0, 0, 0, 0.6),
    2px 2px 0px rgba(0, 0, 0, 0.9); /* 多层阴影增强可读性 */
}

/* 有背景图片时的标题样式 */
.announcement-item.has-image .announcement-title {
  font-size: 28px; /* 更大的字体 */
  text-shadow: 
    0 3px 6px rgba(0, 0, 0, 0.9),
    0 0 12px rgba(0, 0, 0, 0.8),
    3px 3px 0px rgba(0, 0, 0, 1),
    0 0 20px rgba(255, 255, 255, 0.3); /* 白色光晕效果 */
  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 50%, #ffffff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));
}

/* 文字叠加动画效果 */
@keyframes textSlideIn {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes textGlow {
  0%, 100% {
    text-shadow: 
      0 3px 6px rgba(0, 0, 0, 0.9),
      0 0 12px rgba(0, 0, 0, 0.8),
      3px 3px 0px rgba(0, 0, 0, 1),
      0 0 20px rgba(255, 255, 255, 0.3);
  }
  50% {
    text-shadow: 
      0 3px 6px rgba(0, 0, 0, 0.9),
      0 0 12px rgba(0, 0, 0, 0.8),
      3px 3px 0px rgba(0, 0, 0, 1),
      0 0 30px rgba(255, 255, 255, 0.5);
  }
}

/* 应用动画到文字元素 */
.announcement-item.has-image .announcement-title {
  animation: textSlideIn 0.8s ease-out, textGlow 3s ease-in-out infinite;
}

.announcement-item.has-image .announcement-text {
  animation: textSlideIn 1s ease-out 0.2s both;
}

/* 背景图片淡入效果 */
@keyframes imageSlideIn {
  0% {
    opacity: 0;
    transform: scale(1.1);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.announcement-background-image img {
  animation: imageSlideIn 1.2s ease-out;
}

/* 遮罩层渐变效果 */
@keyframes overlayFadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.image-overlay {
  animation: overlayFadeIn 0.6s ease-out 0.3s both;
}

.announcement-text {
  font-size: 18px; /* 增大字体 */
  color: #f1f5f9;
  line-height: 1.6;
  margin-bottom: 0;
  text-align: center; /* 居中对齐 */
  word-spacing: 1px;
  text-shadow: 
    0 2px 4px rgba(0, 0, 0, 0.7),
    0 0 6px rgba(0, 0, 0, 0.5); /* 增强阴影 */
}

/* 有背景图片时的正文样式 */
.announcement-item.has-image .announcement-text {
  font-size: 20px; /* 更大的字体 */
  color: #ffffff;
  font-weight: 600; /* 加粗 */
  text-shadow: 
    0 3px 6px rgba(0, 0, 0, 0.9),
    0 0 10px rgba(0, 0, 0, 0.8),
    2px 2px 0px rgba(0, 0, 0, 1),
    0 0 15px rgba(255, 255, 255, 0.2); /* 白色光晕效果 */
  background: rgba(0, 0, 0, 0.3); /* 半透明背景 */
  padding: 16px 24px;
  border-radius: 12px;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 原图片样式已移除，现在图片作为背景使用 */

/* 优先级标签 */
.priority-badge {
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 12px;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.priority-badge.bg-danger {
  background: rgba(239, 68, 68, 0.8) !important;
  border-color: rgba(239, 68, 68, 0.5);
}

.priority-badge.bg-warning {
  background: rgba(245, 158, 11, 0.8) !important;
  border-color: rgba(245, 158, 11, 0.5);
}

.priority-badge.bg-info {
  background: rgba(6, 182, 212, 0.8) !important;
  border-color: rgba(6, 182, 212, 0.5);
}

/* 计数标签 */
.announcement-header .badge {
  font-size: 10px;
  padding: 4px 8px;
  border-radius: 10px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.1) !important;
  color: white !important;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 轮播控件 */
.announcement-carousel {
  background: transparent;
  position: relative;
}

/* 全局强制隐藏轮播控件的规则 - 最高优先级 */
.announcement-carousel .carousel-control-prev,
.announcement-carousel .carousel-control-next {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
  position: absolute !important;
  left: -9999px !important;
}

/* 针对hide-controls类的额外隐藏规则 */
.announcement-carousel.hide-controls .carousel-control-prev,
.announcement-carousel.hide-controls .carousel-control-next,
.announcement-carousel.hide-controls .carousel-indicators,
.announcement-carousel.hide-controls button[data-bs-slide],
.announcement-carousel.hide-controls [data-bs-slide="prev"],
.announcement-carousel.hide-controls [data-bs-slide="next"] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
  pointer-events: none !important;
  position: absolute !important;
  left: -9999px !important;
  top: -9999px !important;
}

.announcement-carousel .carousel-indicators {
  bottom: 10px !important;
  margin-bottom: 0 !important;
  gap: 12px !important;
  z-index: 15 !important;
}

.announcement-carousel .carousel-indicators button {
  width: 12px !important;
  height: 12px !important;
  border-radius: 50% !important;
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
  background: rgba(255, 255, 255, 0.4) !important;
  backdrop-filter: blur(5px) !important;
  transition: all 0.3s ease !important;
  opacity: 1 !important;
  margin: 0 6px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5) !important;
}

.announcement-carousel .carousel-indicators button.active {
  background: #ffffff !important;
  border-color: rgba(99, 102, 241, 0.8) !important;
  box-shadow: 
    0 0 0 3px rgba(99, 102, 241, 0.4),
    0 2px 12px rgba(0, 0, 0, 0.6) !important;
  transform: scale(1.2) !important;
}

.announcement-carousel .carousel-indicators button:hover {
  background: rgba(255, 255, 255, 0.7) !important;
  border-color: rgba(255, 255, 255, 0.9) !important;
  transform: scale(1.1) !important;
}

/* 注释掉原来的轮播控件样式，防止强制显示
.announcement-carousel .carousel-control-prev,
.announcement-carousel .carousel-control-next {
  width: 48px !important;
  height: 48px !important;
  background: rgba(0, 0, 0, 0.8) !important;
  backdrop-filter: blur(12px) !important;
  border: 2px solid rgba(255, 255, 255, 0.4) !important;
  border-radius: 50% !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
  opacity: 0.9 !important;
  transition: all 0.3s ease !important;
  z-index: 10 !important;
}
*/

/* 注释掉轮播控件的位置和悬浮样式
.announcement-carousel .carousel-control-prev {
  left: 12px !important;
}

.announcement-carousel .carousel-control-next {
  right: 12px !important;
}

.announcement-carousel .carousel-control-prev:hover,
.announcement-carousel .carousel-control-next:hover {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.9) !important;
  border-color: rgba(255, 255, 255, 0.6) !important;
  transform: translateY(-50%) scale(1.1) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5) !important;
}

.announcement-carousel .carousel-control-prev-icon,
.announcement-carousel .carousel-control-next-icon {
  width: 20px !important;
  height: 20px !important;
  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.7)) !important;
}
*/

/* 空状态和加载状态 */
.announcement-board .text-center.py-4 {
  padding: 40px 24px !important;
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  position: relative;
}

.empty-icon {
  font-size: 2.5em;
  opacity: 0.6;
  margin-bottom: 8px;
  display: block;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
}

.announcement-board .text-center .text-muted {
  color: #cbd5e0 !important;
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.3px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 加载器样式 */
.announcement-board .spinner-border {
  width: 1.5rem !important;
  height: 1.5rem !important;
  border-width: 2px !important;
  color: #6366f1 !important;
  opacity: 0.8;
}

/* 现代化公告板增强效果 */

/* 现代化公告板基础样式增强 */
.announcement-board {
  /* 增强的渐变背景 */
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.8) 0%, 
    rgba(30, 30, 60, 0.6) 50%, 
    rgba(0, 0, 0, 0.8) 100%) !important;
  
  /* 增强的光效边框 */
  border: 2px solid transparent !important;
  background-clip: padding-box;
  
  /* 现代化阴影效果 */
  box-shadow: 
    0 25px 50px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2),
    0 0 50px rgba(102, 126, 234, 0.1) !important;
    
  /* 现代化过渡效果 */
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  
  /* 动态边框效果 */
  position: relative;
}

/* 动态边框光效 */
.announcement-board::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, 
    rgba(102, 126, 234, 0.5) 0%, 
    rgba(118, 75, 162, 0.5) 25%, 
    rgba(255, 119, 198, 0.5) 50%, 
    rgba(120, 219, 255, 0.5) 75%, 
    rgba(102, 126, 234, 0.5) 100%);
  border-radius: 18px;
  z-index: -1;
  animation: borderGlow 8s linear infinite;
  opacity: 0.6;
}

@keyframes borderGlow {
  0% { 
    background: linear-gradient(45deg, 
      rgba(102, 126, 234, 0.5) 0%, 
      rgba(118, 75, 162, 0.5) 25%, 
      rgba(255, 119, 198, 0.5) 50%, 
      rgba(120, 219, 255, 0.5) 75%, 
      rgba(102, 126, 234, 0.5) 100%);
  }
  25% { 
    background: linear-gradient(45deg, 
      rgba(118, 75, 162, 0.5) 0%, 
      rgba(255, 119, 198, 0.5) 25%, 
      rgba(120, 219, 255, 0.5) 50%, 
      rgba(102, 126, 234, 0.5) 75%, 
      rgba(118, 75, 162, 0.5) 100%);
  }
  50% { 
    background: linear-gradient(45deg, 
      rgba(255, 119, 198, 0.5) 0%, 
      rgba(120, 219, 255, 0.5) 25%, 
      rgba(102, 126, 234, 0.5) 50%, 
      rgba(118, 75, 162, 0.5) 75%, 
      rgba(255, 119, 198, 0.5) 100%);
  }
  75% { 
    background: linear-gradient(45deg, 
      rgba(120, 219, 255, 0.5) 0%, 
      rgba(102, 126, 234, 0.5) 25%, 
      rgba(118, 75, 162, 0.5) 50%, 
      rgba(255, 119, 198, 0.5) 75%, 
      rgba(120, 219, 255, 0.5) 100%);
  }
  100% { 
    background: linear-gradient(45deg, 
      rgba(102, 126, 234, 0.5) 0%, 
      rgba(118, 75, 162, 0.5) 25%, 
      rgba(255, 119, 198, 0.5) 50%, 
      rgba(120, 219, 255, 0.5) 75%, 
      rgba(102, 126, 234, 0.5) 100%);
  }
}

/* 公告板悬停效果 */
.announcement-board:hover {
  transform: translateY(-5px);
  box-shadow: 
    0 35px 70px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.3),
    0 0 80px rgba(102, 126, 234, 0.2) !important;
}

.announcement-board:hover::before {
  opacity: 0.8;
  animation-duration: 4s;
}

/* 增强的标题效果 */
.announcement-header {
  background: linear-gradient(135deg, 
    rgba(0, 0, 0, 0.9) 0%, 
    rgba(30, 30, 60, 0.8) 50%, 
    rgba(0, 0, 0, 0.9) 100%) !important;
  position: relative;
  overflow: hidden;
}

.announcement-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, 
    transparent, 
    rgba(255, 255, 255, 0.1), 
    transparent);
  animation: headerShine 3s ease-in-out infinite;
}

@keyframes headerShine {
  0% { left: -100%; }
  50% { left: -100%; }
  100% { left: 100%; }
}

.announcement-header h5 {
  position: relative;
  z-index: 2;
}

.header-icon {
  animation: iconPulse 2s ease-in-out infinite;
  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.5));
}

@keyframes iconPulse {
  0%, 100% { 
    transform: scale(1);
    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.5));
  }
  50% { 
    transform: scale(1.1);
    filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.8));
  }
}

/* 增强的徽章效果 */
.announcement-header .badge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  color: white !important;
  font-weight: 600 !important;
  padding: 6px 12px !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3) !important;
  animation: badgeGlow 2s ease-in-out infinite alternate;
}

@keyframes badgeGlow {
  0% { 
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
  }
  100% { 
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);
  }
}

/* 增强的轮播指示器 */
.carousel-indicators {
  bottom: 10px;
}

.carousel-indicators [data-bs-target] {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.4);
  border: 2px solid rgba(255, 255, 255, 0.6);
  transition: all 0.3s ease;
}

.carousel-indicators .active {
  background: rgba(102, 126, 234, 0.8);
  border-color: rgba(102, 126, 234, 1);
  transform: scale(1.2);
  box-shadow: 0 0 10px rgba(102, 126, 234, 0.6);
}

/* 现代化公告项目样式 */
.announcement-item {
  position: relative;
  overflow: hidden;
}

.announcement-item::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, 
    rgba(255, 255, 255, 0.05) 0%, 
    transparent 50%, 
    rgba(0, 0, 0, 0.1) 100%);
  pointer-events: none;
  z-index: 10;
}

/* 空状态现代化 */
.empty-icon {
  font-size: 3rem;
  margin-bottom: 15px;
  display: inline-block;
  animation: emptyFloat 3s ease-in-out infinite;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
}

@keyframes emptyFloat {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

/* 响应式增强 */
@media (max-width: 768px) {
  .announcement-board::before {
    display: none; /* 移动端简化边框动画 */
  }
  
  .announcement-board {
    margin-bottom: 20px;
    border-radius: 12px;
  }
  
  .header-icon {
    animation: none; /* 移动端简化动画 */
  }
  
  .announcement-header::before {
    display: none; /* 移动端简化光效 */
  }
  
  /* 移动端公告图片显示优化 */
  .announcement-item {
    min-height: 200px; /* 移动端减少最小高度 */
    padding: 20px; /* 减少内边距 */
  }
  
  .announcement-item.has-image {
    min-height: 240px; /* 移动端优化高度 */
  }
  
  .announcement-item.has-image .announcement-background-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    overflow: hidden; /* 确保图片不溢出 */
  }
  
  .announcement-item.has-image .announcement-background-image img {
    width: 100%;
    height: 100%;
    object-fit: cover; /* 保持图片比例填充 */
    object-position: center; /* 居中显示 */
    min-height: 240px; /* 确保最小高度 */
  }
}

@media (max-width: 480px) {
  /* 小屏幕手机优化 */
  .announcement-item {
    min-height: 180px;
    padding: 16px;
  }
  
  .announcement-item.has-image {
    min-height: 220px;
  }
  
  .announcement-item.has-image .announcement-background-image img {
    min-height: 220px;
  }
}

/* ========== 简洁分区卡片样式 ========== */
.simple-partition-card {
  transition: all 0.3s ease !important;
  transform: translateY(0) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.simple-partition-card:hover {
  transform: translateY(-8px) !important;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25) !important;
}

/* 简单遮罩 */
.simple-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.5) 100%
  );
  z-index: 1;
}

/* 卡片内容 */
.simple-card-body {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
  padding: 20px !important;
  padding-bottom: 60px !important; /* 为右下角按钮留出空间 */
}

/* 卡片标题 */
.simple-card-title {
  color: white !important;
  font-weight: 600 !important;
  font-size: 1.1rem !important;
  margin-bottom: 8px !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8) !important;
  display: flex;
  align-items: center;
}

/* 卡片文本 */
.simple-card-text {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 0.9rem !important;
  margin-bottom: auto !important;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8) !important;
}

/* 简洁进入按钮 */
.simple-enter-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 8px !important;
  padding: 8px 16px !important;
  font-weight: 500 !important;
  transition: all 0.2s ease !important;
  position: absolute !important;
  bottom: 16px !important;
  right: 16px !important;
  margin-top: 0 !important;
}

.simple-enter-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  color: white !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
}

.simple-enter-btn:active {
  transform: translateY(0) !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/announcementBoardDark.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;;;;;;;;;;;;;;;;EAgBE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA,qBAAqB;;AAErB,sBAAsB;AACtB;;;EAGE,yCAAyC;EACzC,qDAAqD;EACrD,6DAA6D;EAC7D,sDAAsD;EACtD;;;sDAGoD;AACtD;;AAEA,cAAc;AACd;;;;EAIE,4BAA4B;EAC5B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,+CAA+C;EAC/C,yCAAyC;EACzC,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qDAAqD;EACrD,6DAA6D;;EAE7D,sBAAsB;EACtB,qDAAqD;EACrD;;;qDAGmD;;EAEnD,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B,EAAE,SAAS;AACxC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;mCAGiC;EACjC,oBAAoB;EACpB,UAAU;EACV,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,yCAAyC;EACzC,iDAAiD;EACjD;;;qDAGmD;AACrD;;AAEA,0BAA0B;AAC1B;;;EAGE,yCAAyC;EACzC,sCAAsC;EACtC,8CAA8C;EAC9C,uBAAuB;EACvB,6DAA6D;EAC7D,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;;;EAGE,uBAAuB;EACvB,gBAAgB;EAChB,yCAAyC;EACzC,SAAS;AACX;;AAEA;;;EAGE,+CAA+C;EAC/C,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,iCAAiC;EACjC,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB,EAAE,gBAAgB;EACnC,aAAa;EACb,uBAAuB,EAAE,WAAW;EACpC,uBAAuB;EACvB,4BAA4B,EAAE,UAAU;EACxC,2BAA2B,EAAE,SAAS;EACtC,8DAA8D;AAChE;;AAEA,cAAc;AACd;EACE,uBAAuB,EAAE,WAAW;EACpC,iBAAiB,EAAE,gBAAgB;AACrC;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,qCAAqC,EAAE,cAAc;AACvD;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,8DAA8D;AAChE;;AAEA,oBAAoB;AACpB;EACE,kCAAkC;AACpC;;AAEA,0BAA0B;AAC1B;EACE,4BAA4B,EAAE,UAAU;AAC1C;;AAEA;EACE,4BAA4B,EAAE,UAAU;AAC1C;;AAEA;EACE,4BAA4B,EAAE,UAAU;AAC1C;;AAEA,gCAAgC;AAChC;;;EAGE,kCAAkC;AACpC;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB,EAAE,WAAW;EAC/B,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,yBAAyB,EAAE,cAAc;AAC3C;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,gBAAgB,EAAE,UAAU;EAC5B,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB,EAAE,SAAS;EAClC,gBAAgB;EAChB,qBAAqB;EACrB;;;kCAGgC,EAAE,cAAc;AAClD;;AAEA,gBAAgB;AAChB;EACE,eAAe,EAAE,UAAU;EAC3B;;;;qCAImC,EAAE,WAAW;EAChD,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE;;;;uCAImC;EACrC;EACA;IACE;;;;uCAImC;EACrC;AACF;;AAEA,cAAc;AACd;EACE,sEAAsE;AACxE;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,aAAa;AACb;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA,YAAY;AACZ;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAE,SAAS;EAC7B,iBAAiB;EACjB;;8BAE4B,EAAE,SAAS;AACzC;;AAEA,gBAAgB;AAChB;EACE,eAAe,EAAE,UAAU;EAC3B,cAAc;EACd,gBAAgB,EAAE,OAAO;EACzB;;;;qCAImC,EAAE,WAAW;EAChD,8BAA8B,EAAE,UAAU;EAC1C,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA,wBAAwB;;AAExB,UAAU;AACV;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;EACzC,wCAAwC;AAC1C;;AAEA;EACE,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;EAC9C,qCAAqC;AACvC;;AAEA;EACE,6CAA6C;EAC7C,oCAAoC;AACtC;;AAEA,SAAS;AACT;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,+CAA+C;EAC/C,uBAAuB;EACvB,0CAA0C;EAC1C,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;;EAEE,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,+BAA+B;EAC/B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;;;;;;EAME,wBAAwB;EACxB,6BAA6B;EAC7B,qBAAqB;EACrB,+BAA+B;EAC/B,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,qDAAqD;EACrD,+CAA+C;EAC/C,qCAAqC;EACrC,oCAAoC;EACpC,qBAAqB;EACrB,wBAAwB;EACxB,mDAAmD;AACrD;;AAEA;EACE,8BAA8B;EAC9B,gDAAgD;EAChD;;4CAE0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;CAeC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;CAwBC;;AAED,aAAa;AACb;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,wBAAwB;EACxB,yBAAyB;EACzB,4BAA4B;EAC5B,yBAAyB;EACzB,YAAY;AACd;;AAEA,eAAe;;AAEf,iBAAiB;AACjB;EACE,YAAY;EACZ;;;uCAGqC;;EAErC,YAAY;EACZ,wCAAwC;EACxC,4BAA4B;;EAE5B,YAAY;EACZ;;;;gDAI8C;;EAE9C,YAAY;EACZ,4DAA4D;;EAE5D,WAAW;EACX,kBAAkB;AACpB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;;;kCAKgC;EAChC,mBAAmB;EACnB,WAAW;EACX,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE;IACE;;;;;oCAKgC;EAClC;EACA;IACE;;;;;mCAK+B;EACjC;EACA;IACE;;;;;oCAKgC;EAClC;EACA;IACE;;;;;oCAKgC;EAClC;EACA;IACE;;;;;oCAKgC;EAClC;AACF;;AAEA,YAAY;AACZ;EACE,2BAA2B;EAC3B;;;;gDAI8C;AAChD;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE;;;uCAGqC;EACrC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;gBAGc;EACd,8CAA8C;AAChD;;AAEA;EACE,KAAK,WAAW,EAAE;EAClB,MAAM,WAAW,EAAE;EACnB,OAAO,UAAU,EAAE;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,4CAA4C;EAC5C,sDAAsD;AACxD;;AAEA;EACE;IACE,mBAAmB;IACnB,sDAAsD;EACxD;EACA;IACE,qBAAqB;IACrB,sDAAsD;EACxD;AACF;;AAEA,YAAY;AACZ;EACE,wEAAwE;EACxE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,0DAA0D;EAC1D,sDAAsD;AACxD;;AAEA;EACE;IACE,+CAA+C;EACjD;EACA;IACE,+CAA+C;EACjD;AACF;;AAEA,aAAa;AACb;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;4BAG0B;EAC1B,oBAAoB;EACpB,WAAW;AACb;;AAEA,WAAW;AACX;EACE,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA,UAAU;AACV;EACE;IACE,aAAa,EAAE,cAAc;EAC/B;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,eAAe,EAAE,YAAY;EAC/B;;EAEA;IACE,aAAa,EAAE,YAAY;EAC7B;;EAEA,gBAAgB;EAChB;IACE,iBAAiB,EAAE,cAAc;IACjC,aAAa,EAAE,UAAU;EAC3B;;EAEA;IACE,iBAAiB,EAAE,YAAY;EACjC;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB,EAAE,YAAY;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAE,aAAa;IAChC,uBAAuB,EAAE,SAAS;IAClC,iBAAiB,EAAE,WAAW;EAChC;AACF;;AAEA;EACE,YAAY;EACZ;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE,oCAAoC;EACpC,mCAAmC;EACnC,qDAAqD;AACvD;;AAEA;EACE,sCAAsC;EACtC,sDAAsD;AACxD;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;GAIC;EACD,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,YAAY;EACZ,wBAAwB;EACxB,+BAA+B,EAAE,eAAe;AAClD;;AAEA,SAAS;AACT;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,oDAAoD;EACpD,aAAa;EACb,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,2CAA2C;EAC3C,4BAA4B;EAC5B,8BAA8B;EAC9B,oDAAoD;AACtD;;AAEA,WAAW;AACX;EACE,+CAA+C;EAC/C,qDAAqD;EACrD,uBAAuB;EACvB,sCAAsC;EACtC,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,oCAAoC;EACpC,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;EACjD,uBAAuB;EACvB,sCAAsC;EACtC,oDAAoD;AACtD;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":["/* ========== 隐藏所有文字内容 - 纯图片效果 ========== */\n.announcement-content,\n.announcement-title,\n.announcement-text,\n.priority-badge,\n.priority-high .priority-badge,\n.priority-medium .priority-badge,\n.priority-low .priority-badge,\n.announcement-item .announcement-title,\n.announcement-item .announcement-text,\n.announcement-item .announcement-content,\n.carousel-item .announcement-title,\n.carousel-item .announcement-text,\n.carousel-item .announcement-content,\n.has-image .announcement-title,\n.has-image .announcement-text,\n.has-image .announcement-content {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n/* 确保图片覆盖整个容器 */\n.announcement-item.has-image .announcement-background-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n}\n\n.announcement-item.has-image .announcement-background-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n}\n\n/* 隐藏图片叠加层，保持纯净的图片效果 */\n.image-overlay {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n}\n\n/* 黑色磨砂玻璃效果 - 无动画版本 */\n\n/* 🔥 强制生效 - 最高优先级样式 */\n.announcement-board,\n.card.announcement-board,\ndiv.announcement-board {\n  background: rgba(0, 0, 0, 0.7) !important;\n  backdrop-filter: blur(25px) saturate(130%) !important;\n  -webkit-backdrop-filter: blur(25px) saturate(130%) !important;\n  border: 2px solid rgba(255, 255, 255, 0.25) !important;\n  box-shadow: \n    0 20px 60px rgba(0, 0, 0, 0.8),\n    0 8px 20px rgba(0, 0, 0, 0.5),\n    inset 0 2px 0 rgba(255, 255, 255, 0.15) !important;\n}\n\n/* 强制取消所有左边框 */\n.announcement-board *,\n.announcement-board .announcement-item,\n.announcement-board .card-body,\n.announcement-board .card-body * {\n  border-left: none !important;\n  border-left-color: transparent !important;\n  border-left-width: 0 !important;\n}\n\n/* 强制覆盖Bootstrap默认样式 */\n.card-header.announcement-header {\n  background-color: rgba(0, 0, 0, 0.9) !important;\n  background: rgba(0, 0, 0, 0.9) !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;\n}\n\n.announcement-board {\n  /* 黑色磨砂玻璃核心样式 - 始终生效，增强效果 */\n  background: rgba(0, 0, 0, 0.6) !important;\n  backdrop-filter: blur(20px) saturate(120%) !important;\n  -webkit-backdrop-filter: blur(20px) saturate(120%) !important;\n  \n  /* 边框和阴影 - 始终生效，增强效果 */\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  box-shadow: \n    0 15px 50px rgba(0, 0, 0, 0.7),\n    0 6px 16px rgba(0, 0, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;\n  \n  /* 基础样式 */\n  border-radius: 16px;\n  overflow: hidden;\n  margin-bottom: 24px;\n  position: relative;\n  transition: none !important; /* 取消动画 */\n}\n\n/* 简单的磨砂反光层 */\n.announcement-board::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, \n    rgba(255, 255, 255, 0.08) 0%,\n    rgba(255, 255, 255, 0.02) 50%,\n    rgba(255, 255, 255, 0.08) 100%);\n  pointer-events: none;\n  z-index: 1;\n  opacity: 0.5;\n}\n\n/* 移除悬浮效果，让效果始终保持 */\n.announcement-board:hover {\n  /* 保持和默认状态一样的效果 */\n  background: rgba(0, 0, 0, 0.6) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n  box-shadow: \n    0 15px 50px rgba(0, 0, 0, 0.7),\n    0 6px 16px rgba(0, 0, 0, 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;\n}\n\n/* 黑色磨砂头部 - 增强黑色背景，提高优先级 */\n.announcement-board .card-header.announcement-header,\n.announcement-board .card-header,\n.announcement-board .announcement-header {\n  background: rgba(0, 0, 0, 0.9) !important;\n  backdrop-filter: blur(15px) !important;\n  -webkit-backdrop-filter: blur(15px) !important;\n  color: white !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15) !important;\n  padding: 20px 24px !important;\n  position: relative;\n  z-index: 3;\n  border-top-left-radius: 16px;\n  border-top-right-radius: 16px;\n}\n\n.announcement-board .card-header.announcement-header h5,\n.announcement-board .card-header h5,\n.announcement-board .announcement-header h5 {\n  color: white !important;\n  font-weight: 600;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  margin: 0;\n}\n\n.announcement-board .card-header.announcement-header .badge,\n.announcement-board .card-header .badge,\n.announcement-board .announcement-header .badge {\n  background: rgba(255, 255, 255, 0.9) !important;\n  color: #333 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.announcement-board .header-icon {\n  font-size: 1.3em;\n  margin-right: 10px;\n  color: white !important;\n  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.8));\n}\n\n/* 公告内容区域 - 支持背景图片和文字叠加 */\n.announcement-item {\n  position: relative;\n  padding: 32px;\n  margin: 0;\n  background: rgba(16, 24, 40, 0.4);\n  backdrop-filter: blur(8px);\n  border-radius: 0;\n  overflow: hidden;\n  min-height: 250px; /* 确保有足够高度显示内容 */\n  display: flex;\n  align-items: flex-start; /* 改为顶部对齐 */\n  justify-content: center;\n  border-left: none !important; /* 取消左边框 */\n  transition: none !important; /* 取消动画 */\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;\n}\n\n/* 有背景图片时的样式 */\n.announcement-item.has-image {\n  background: transparent; /* 移除默认背景 */\n  min-height: 320px; /* 增加高度以更好展示图片 */\n}\n\n/* 背景图片容器 */\n.announcement-background-image {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  overflow: hidden;\n}\n\n.announcement-background-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  filter: brightness(0.7) contrast(1.1); /* 稍微暗化以突出文字 */\n}\n\n/* 图片遮罩层 - 增强文字可读性 */\n.image-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(0, 0, 0, 0.6) 0%,\n    rgba(0, 0, 0, 0.3) 50%,\n    rgba(0, 0, 0, 0.7) 100%\n  );\n  z-index: 2;\n}\n\n.announcement-item:hover {\n  /* 保持和默认状态一样的效果 */\n  background: rgba(0, 0, 0, 0.3) !important;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.05) !important;\n}\n\n/* 有背景图片时悬浮效果不改变背景 */\n.announcement-item.has-image:hover {\n  background: transparent !important;\n}\n\n/* 优先级样式 - 取消左边框，改用背景色区分 */\n.announcement-item.priority-high {\n  border-left: none !important; /* 取消左边框 */\n}\n\n.announcement-item.priority-medium {\n  border-left: none !important; /* 取消左边框 */\n}\n\n.announcement-item.priority-low {\n  border-left: none !important; /* 取消左边框 */\n}\n\n/* 有背景图片时的优先级样式（不显示背景色，通过标签区分） */\n.announcement-item.has-image.priority-high,\n.announcement-item.has-image.priority-medium,\n.announcement-item.has-image.priority-low {\n  background: transparent !important;\n}\n\n/* 文字样式 - 叠加在图片上 */\n.announcement-content {\n  position: relative;\n  z-index: 3;\n  width: 100%;\n  text-align: center; /* 文字居中显示 */\n  padding: 20px 20px 0 20px; /* 上方增加内边距，底部减少 */\n}\n\n/* 增强文字可读性 - 在有背景图片时 */\n.announcement-item.has-image .announcement-content {\n  text-align: center;\n  padding: 30px 40px 0 40px; /* 顶部增加更多内边距 */\n}\n\n.announcement-title {\n  font-size: 24px; /* 增大字体 */\n  font-weight: 800; /* 更粗的字体 */\n  color: #ffffff;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center; /* 居中对齐 */\n  line-height: 1.3;\n  letter-spacing: 0.5px;\n  text-shadow: \n    0 2px 4px rgba(0, 0, 0, 0.8),\n    0 0 8px rgba(0, 0, 0, 0.6),\n    2px 2px 0px rgba(0, 0, 0, 0.9); /* 多层阴影增强可读性 */\n}\n\n/* 有背景图片时的标题样式 */\n.announcement-item.has-image .announcement-title {\n  font-size: 28px; /* 更大的字体 */\n  text-shadow: \n    0 3px 6px rgba(0, 0, 0, 0.9),\n    0 0 12px rgba(0, 0, 0, 0.8),\n    3px 3px 0px rgba(0, 0, 0, 1),\n    0 0 20px rgba(255, 255, 255, 0.3); /* 白色光晕效果 */\n  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 50%, #ffffff 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8));\n}\n\n/* 文字叠加动画效果 */\n@keyframes textSlideIn {\n  0% {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes textGlow {\n  0%, 100% {\n    text-shadow: \n      0 3px 6px rgba(0, 0, 0, 0.9),\n      0 0 12px rgba(0, 0, 0, 0.8),\n      3px 3px 0px rgba(0, 0, 0, 1),\n      0 0 20px rgba(255, 255, 255, 0.3);\n  }\n  50% {\n    text-shadow: \n      0 3px 6px rgba(0, 0, 0, 0.9),\n      0 0 12px rgba(0, 0, 0, 0.8),\n      3px 3px 0px rgba(0, 0, 0, 1),\n      0 0 30px rgba(255, 255, 255, 0.5);\n  }\n}\n\n/* 应用动画到文字元素 */\n.announcement-item.has-image .announcement-title {\n  animation: textSlideIn 0.8s ease-out, textGlow 3s ease-in-out infinite;\n}\n\n.announcement-item.has-image .announcement-text {\n  animation: textSlideIn 1s ease-out 0.2s both;\n}\n\n/* 背景图片淡入效果 */\n@keyframes imageSlideIn {\n  0% {\n    opacity: 0;\n    transform: scale(1.1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.announcement-background-image img {\n  animation: imageSlideIn 1.2s ease-out;\n}\n\n/* 遮罩层渐变效果 */\n@keyframes overlayFadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.image-overlay {\n  animation: overlayFadeIn 0.6s ease-out 0.3s both;\n}\n\n.announcement-text {\n  font-size: 18px; /* 增大字体 */\n  color: #f1f5f9;\n  line-height: 1.6;\n  margin-bottom: 0;\n  text-align: center; /* 居中对齐 */\n  word-spacing: 1px;\n  text-shadow: \n    0 2px 4px rgba(0, 0, 0, 0.7),\n    0 0 6px rgba(0, 0, 0, 0.5); /* 增强阴影 */\n}\n\n/* 有背景图片时的正文样式 */\n.announcement-item.has-image .announcement-text {\n  font-size: 20px; /* 更大的字体 */\n  color: #ffffff;\n  font-weight: 600; /* 加粗 */\n  text-shadow: \n    0 3px 6px rgba(0, 0, 0, 0.9),\n    0 0 10px rgba(0, 0, 0, 0.8),\n    2px 2px 0px rgba(0, 0, 0, 1),\n    0 0 15px rgba(255, 255, 255, 0.2); /* 白色光晕效果 */\n  background: rgba(0, 0, 0, 0.3); /* 半透明背景 */\n  padding: 16px 24px;\n  border-radius: 12px;\n  backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n/* 原图片样式已移除，现在图片作为背景使用 */\n\n/* 优先级标签 */\n.priority-badge {\n  font-size: 11px;\n  font-weight: 700;\n  padding: 4px 8px;\n  border-radius: 12px;\n  letter-spacing: 0.2px;\n  display: inline-flex;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);\n}\n\n.priority-badge.bg-danger {\n  background: rgba(239, 68, 68, 0.8) !important;\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.priority-badge.bg-warning {\n  background: rgba(245, 158, 11, 0.8) !important;\n  border-color: rgba(245, 158, 11, 0.5);\n}\n\n.priority-badge.bg-info {\n  background: rgba(6, 182, 212, 0.8) !important;\n  border-color: rgba(6, 182, 212, 0.5);\n}\n\n/* 计数标签 */\n.announcement-header .badge {\n  font-size: 10px;\n  padding: 4px 8px;\n  border-radius: 10px;\n  font-weight: 600;\n  background: rgba(255, 255, 255, 0.1) !important;\n  color: white !important;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n/* 轮播控件 */\n.announcement-carousel {\n  background: transparent;\n  position: relative;\n}\n\n/* 全局强制隐藏轮播控件的规则 - 最高优先级 */\n.announcement-carousel .carousel-control-prev,\n.announcement-carousel .carousel-control-next {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n  position: absolute !important;\n  left: -9999px !important;\n}\n\n/* 针对hide-controls类的额外隐藏规则 */\n.announcement-carousel.hide-controls .carousel-control-prev,\n.announcement-carousel.hide-controls .carousel-control-next,\n.announcement-carousel.hide-controls .carousel-indicators,\n.announcement-carousel.hide-controls button[data-bs-slide],\n.announcement-carousel.hide-controls [data-bs-slide=\"prev\"],\n.announcement-carousel.hide-controls [data-bs-slide=\"next\"] {\n  display: none !important;\n  visibility: hidden !important;\n  opacity: 0 !important;\n  pointer-events: none !important;\n  position: absolute !important;\n  left: -9999px !important;\n  top: -9999px !important;\n}\n\n.announcement-carousel .carousel-indicators {\n  bottom: 10px !important;\n  margin-bottom: 0 !important;\n  gap: 12px !important;\n  z-index: 15 !important;\n}\n\n.announcement-carousel .carousel-indicators button {\n  width: 12px !important;\n  height: 12px !important;\n  border-radius: 50% !important;\n  border: 2px solid rgba(255, 255, 255, 0.8) !important;\n  background: rgba(255, 255, 255, 0.4) !important;\n  backdrop-filter: blur(5px) !important;\n  transition: all 0.3s ease !important;\n  opacity: 1 !important;\n  margin: 0 6px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.5) !important;\n}\n\n.announcement-carousel .carousel-indicators button.active {\n  background: #ffffff !important;\n  border-color: rgba(99, 102, 241, 0.8) !important;\n  box-shadow: \n    0 0 0 3px rgba(99, 102, 241, 0.4),\n    0 2px 12px rgba(0, 0, 0, 0.6) !important;\n  transform: scale(1.2) !important;\n}\n\n.announcement-carousel .carousel-indicators button:hover {\n  background: rgba(255, 255, 255, 0.7) !important;\n  border-color: rgba(255, 255, 255, 0.9) !important;\n  transform: scale(1.1) !important;\n}\n\n/* 注释掉原来的轮播控件样式，防止强制显示\n.announcement-carousel .carousel-control-prev,\n.announcement-carousel .carousel-control-next {\n  width: 48px !important;\n  height: 48px !important;\n  background: rgba(0, 0, 0, 0.8) !important;\n  backdrop-filter: blur(12px) !important;\n  border: 2px solid rgba(255, 255, 255, 0.4) !important;\n  border-radius: 50% !important;\n  top: 50% !important;\n  transform: translateY(-50%) !important;\n  opacity: 0.9 !important;\n  transition: all 0.3s ease !important;\n  z-index: 10 !important;\n}\n*/\n\n/* 注释掉轮播控件的位置和悬浮样式\n.announcement-carousel .carousel-control-prev {\n  left: 12px !important;\n}\n\n.announcement-carousel .carousel-control-next {\n  right: 12px !important;\n}\n\n.announcement-carousel .carousel-control-prev:hover,\n.announcement-carousel .carousel-control-next:hover {\n  opacity: 1 !important;\n  background: rgba(0, 0, 0, 0.9) !important;\n  border-color: rgba(255, 255, 255, 0.6) !important;\n  transform: translateY(-50%) scale(1.1) !important;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5) !important;\n}\n\n.announcement-carousel .carousel-control-prev-icon,\n.announcement-carousel .carousel-control-next-icon {\n  width: 20px !important;\n  height: 20px !important;\n  filter: drop-shadow(0 1px 3px rgba(0, 0, 0, 0.7)) !important;\n}\n*/\n\n/* 空状态和加载状态 */\n.announcement-board .text-center.py-4 {\n  padding: 40px 24px !important;\n  background: rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  position: relative;\n}\n\n.empty-icon {\n  font-size: 2.5em;\n  opacity: 0.6;\n  margin-bottom: 8px;\n  display: block;\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));\n}\n\n.announcement-board .text-center .text-muted {\n  color: #cbd5e0 !important;\n  font-weight: 500;\n  font-size: 15px;\n  letter-spacing: 0.3px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n/* 加载器样式 */\n.announcement-board .spinner-border {\n  width: 1.5rem !important;\n  height: 1.5rem !important;\n  border-width: 2px !important;\n  color: #6366f1 !important;\n  opacity: 0.8;\n}\n\n/* 现代化公告板增强效果 */\n\n/* 现代化公告板基础样式增强 */\n.announcement-board {\n  /* 增强的渐变背景 */\n  background: linear-gradient(135deg, \n    rgba(0, 0, 0, 0.8) 0%, \n    rgba(30, 30, 60, 0.6) 50%, \n    rgba(0, 0, 0, 0.8) 100%) !important;\n  \n  /* 增强的光效边框 */\n  border: 2px solid transparent !important;\n  background-clip: padding-box;\n  \n  /* 现代化阴影效果 */\n  box-shadow: \n    0 25px 50px rgba(0, 0, 0, 0.4),\n    0 0 0 1px rgba(255, 255, 255, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2),\n    0 0 50px rgba(102, 126, 234, 0.1) !important;\n    \n  /* 现代化过渡效果 */\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  \n  /* 动态边框效果 */\n  position: relative;\n}\n\n/* 动态边框光效 */\n.announcement-board::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  background: linear-gradient(45deg, \n    rgba(102, 126, 234, 0.5) 0%, \n    rgba(118, 75, 162, 0.5) 25%, \n    rgba(255, 119, 198, 0.5) 50%, \n    rgba(120, 219, 255, 0.5) 75%, \n    rgba(102, 126, 234, 0.5) 100%);\n  border-radius: 18px;\n  z-index: -1;\n  animation: borderGlow 8s linear infinite;\n  opacity: 0.6;\n}\n\n@keyframes borderGlow {\n  0% { \n    background: linear-gradient(45deg, \n      rgba(102, 126, 234, 0.5) 0%, \n      rgba(118, 75, 162, 0.5) 25%, \n      rgba(255, 119, 198, 0.5) 50%, \n      rgba(120, 219, 255, 0.5) 75%, \n      rgba(102, 126, 234, 0.5) 100%);\n  }\n  25% { \n    background: linear-gradient(45deg, \n      rgba(118, 75, 162, 0.5) 0%, \n      rgba(255, 119, 198, 0.5) 25%, \n      rgba(120, 219, 255, 0.5) 50%, \n      rgba(102, 126, 234, 0.5) 75%, \n      rgba(118, 75, 162, 0.5) 100%);\n  }\n  50% { \n    background: linear-gradient(45deg, \n      rgba(255, 119, 198, 0.5) 0%, \n      rgba(120, 219, 255, 0.5) 25%, \n      rgba(102, 126, 234, 0.5) 50%, \n      rgba(118, 75, 162, 0.5) 75%, \n      rgba(255, 119, 198, 0.5) 100%);\n  }\n  75% { \n    background: linear-gradient(45deg, \n      rgba(120, 219, 255, 0.5) 0%, \n      rgba(102, 126, 234, 0.5) 25%, \n      rgba(118, 75, 162, 0.5) 50%, \n      rgba(255, 119, 198, 0.5) 75%, \n      rgba(120, 219, 255, 0.5) 100%);\n  }\n  100% { \n    background: linear-gradient(45deg, \n      rgba(102, 126, 234, 0.5) 0%, \n      rgba(118, 75, 162, 0.5) 25%, \n      rgba(255, 119, 198, 0.5) 50%, \n      rgba(120, 219, 255, 0.5) 75%, \n      rgba(102, 126, 234, 0.5) 100%);\n  }\n}\n\n/* 公告板悬停效果 */\n.announcement-board:hover {\n  transform: translateY(-5px);\n  box-shadow: \n    0 35px 70px rgba(0, 0, 0, 0.5),\n    0 0 0 1px rgba(255, 255, 255, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3),\n    0 0 80px rgba(102, 126, 234, 0.2) !important;\n}\n\n.announcement-board:hover::before {\n  opacity: 0.8;\n  animation-duration: 4s;\n}\n\n/* 增强的标题效果 */\n.announcement-header {\n  background: linear-gradient(135deg, \n    rgba(0, 0, 0, 0.9) 0%, \n    rgba(30, 30, 60, 0.8) 50%, \n    rgba(0, 0, 0, 0.9) 100%) !important;\n  position: relative;\n  overflow: hidden;\n}\n\n.announcement-header::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, \n    transparent, \n    rgba(255, 255, 255, 0.1), \n    transparent);\n  animation: headerShine 3s ease-in-out infinite;\n}\n\n@keyframes headerShine {\n  0% { left: -100%; }\n  50% { left: -100%; }\n  100% { left: 100%; }\n}\n\n.announcement-header h5 {\n  position: relative;\n  z-index: 2;\n}\n\n.header-icon {\n  animation: iconPulse 2s ease-in-out infinite;\n  filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.5));\n}\n\n@keyframes iconPulse {\n  0%, 100% { \n    transform: scale(1);\n    filter: drop-shadow(0 0 10px rgba(255, 255, 255, 0.5));\n  }\n  50% { \n    transform: scale(1.1);\n    filter: drop-shadow(0 0 15px rgba(255, 255, 255, 0.8));\n  }\n}\n\n/* 增强的徽章效果 */\n.announcement-header .badge {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;\n  color: white !important;\n  font-weight: 600 !important;\n  padding: 6px 12px !important;\n  border-radius: 12px !important;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3) !important;\n  animation: badgeGlow 2s ease-in-out infinite alternate;\n}\n\n@keyframes badgeGlow {\n  0% { \n    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n  }\n  100% { \n    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.5);\n  }\n}\n\n/* 增强的轮播指示器 */\n.carousel-indicators {\n  bottom: 10px;\n}\n\n.carousel-indicators [data-bs-target] {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.4);\n  border: 2px solid rgba(255, 255, 255, 0.6);\n  transition: all 0.3s ease;\n}\n\n.carousel-indicators .active {\n  background: rgba(102, 126, 234, 0.8);\n  border-color: rgba(102, 126, 234, 1);\n  transform: scale(1.2);\n  box-shadow: 0 0 10px rgba(102, 126, 234, 0.6);\n}\n\n/* 现代化公告项目样式 */\n.announcement-item {\n  position: relative;\n  overflow: hidden;\n}\n\n.announcement-item::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, \n    rgba(255, 255, 255, 0.05) 0%, \n    transparent 50%, \n    rgba(0, 0, 0, 0.1) 100%);\n  pointer-events: none;\n  z-index: 10;\n}\n\n/* 空状态现代化 */\n.empty-icon {\n  font-size: 3rem;\n  margin-bottom: 15px;\n  display: inline-block;\n  animation: emptyFloat 3s ease-in-out infinite;\n  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));\n}\n\n@keyframes emptyFloat {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-10px); }\n}\n\n/* 响应式增强 */\n@media (max-width: 768px) {\n  .announcement-board::before {\n    display: none; /* 移动端简化边框动画 */\n  }\n  \n  .announcement-board {\n    margin-bottom: 20px;\n    border-radius: 12px;\n  }\n  \n  .header-icon {\n    animation: none; /* 移动端简化动画 */\n  }\n  \n  .announcement-header::before {\n    display: none; /* 移动端简化光效 */\n  }\n  \n  /* 移动端公告图片显示优化 */\n  .announcement-item {\n    min-height: 200px; /* 移动端减少最小高度 */\n    padding: 20px; /* 减少内边距 */\n  }\n  \n  .announcement-item.has-image {\n    min-height: 240px; /* 移动端优化高度 */\n  }\n  \n  .announcement-item.has-image .announcement-background-image {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    overflow: hidden; /* 确保图片不溢出 */\n  }\n  \n  .announcement-item.has-image .announcement-background-image img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover; /* 保持图片比例填充 */\n    object-position: center; /* 居中显示 */\n    min-height: 240px; /* 确保最小高度 */\n  }\n}\n\n@media (max-width: 480px) {\n  /* 小屏幕手机优化 */\n  .announcement-item {\n    min-height: 180px;\n    padding: 16px;\n  }\n  \n  .announcement-item.has-image {\n    min-height: 220px;\n  }\n  \n  .announcement-item.has-image .announcement-background-image img {\n    min-height: 220px;\n  }\n}\n\n/* ========== 简洁分区卡片样式 ========== */\n.simple-partition-card {\n  transition: all 0.3s ease !important;\n  transform: translateY(0) !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n}\n\n.simple-partition-card:hover {\n  transform: translateY(-8px) !important;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25) !important;\n}\n\n/* 简单遮罩 */\n.simple-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(0, 0, 0, 0.3) 0%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  z-index: 1;\n}\n\n/* 卡片内容 */\n.simple-card-body {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  height: 100%;\n  padding: 20px !important;\n  padding-bottom: 60px !important; /* 为右下角按钮留出空间 */\n}\n\n/* 卡片标题 */\n.simple-card-title {\n  color: white !important;\n  font-weight: 600 !important;\n  font-size: 1.1rem !important;\n  margin-bottom: 8px !important;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8) !important;\n  display: flex;\n  align-items: center;\n}\n\n/* 卡片文本 */\n.simple-card-text {\n  color: rgba(255, 255, 255, 0.85) !important;\n  font-size: 0.9rem !important;\n  margin-bottom: auto !important;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8) !important;\n}\n\n/* 简洁进入按钮 */\n.simple-enter-btn {\n  background: rgba(255, 255, 255, 0.2) !important;\n  border: 1px solid rgba(255, 255, 255, 0.3) !important;\n  color: white !important;\n  backdrop-filter: blur(10px) !important;\n  border-radius: 8px !important;\n  padding: 8px 16px !important;\n  font-weight: 500 !important;\n  transition: all 0.2s ease !important;\n  position: absolute !important;\n  bottom: 16px !important;\n  right: 16px !important;\n  margin-top: 0 !important;\n}\n\n.simple-enter-btn:hover {\n  background: rgba(255, 255, 255, 0.3) !important;\n  border-color: rgba(255, 255, 255, 0.5) !important;\n  color: white !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;\n}\n\n.simple-enter-btn:active {\n  transform: translateY(0) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
